import t from "unist-util-map";

function r() {
  return (r = Object.assign || function (t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

export default function (e) {
  var n = 0;
  return t(e, function (t) {
    if ("text" === t.type && "string" == typeof t.value) {
      var e = {
        start: n,
        end: n += t.value.length
      },
          a = t.data;
      return r({}, t, {
        data: r({}, void 0 === a ? {} : a, {
          textOffset: e
        })
      });
    }

    return t;
  });
}